// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonActionModal from "../Common/CommonActionModal";

// icons
import AddCircleIcon from '@mui/icons-material/AddCircle';
import TableViewIcon from "@mui/icons-material/TableView";
import AgentRunDetail from "./AgentRunDetail";


class AgentRunCreate extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            button: this.props.button || {
                icon: AddCircleIcon,
                label: 'Добавить',
                color: 'primary',
            },
            ready: true,
        })
    }

    async beforeModalOpen(){
        let formFields = await this.retrieveFields()
        return {
            modalLabel: 'Запуск агента',
            modalIcon: TableViewIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
                object: this.props.object,
            },
        }
    }

    async retrieveFields(){
        const url = `agent_run/create_form/`;
        const api = new BaseApi();
        let response = await api.get(
            url,
            {
                fields: JSON.stringify(
                    [
                        'agent',
                    ]
                )
            }
        );
        return response.data
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(form.state.formData.entries());
        const url = `agent_run/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formDataObj
        );
        if (response.status === 201) {
            if (typeof this.props.callBack == 'function') {
                this.setState({
                    mainComponent: AgentRunDetail,
                    mainComponentProps: {
                        params: {
                            agentRunId: response.data.id
                        }
                    },
                    size: 'sm',
                    width: 'calc(80vw)',
                    height: 'calc(80vh)'
                })
                // await this.props.callBack();
            }
            // await this.setModalOpenFalse();
        }
        return response
    }

    async beforeModalClose(){
        await this.props.callBack();
    }
}

export default AgentRunCreate
